import { render, staticRenderFns } from "./TkLink.vue?vue&type=template&id=580366c8&"
import script from "./TkLink.vue?vue&type=script&lang=js&"
export * from "./TkLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports